import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PwaService {
  private links: any = {
    iosURL: 'https://apps.apple.com/us/app/go-mapfre/id1589952585',
    androidURL:
      'https://play.google.com/store/apps/details?id=com.mapfreinsurance.myaccount',
    showAppBanner: true,
  };
  private linkSource = new BehaviorSubject<any>(this.links);
  $appLinks = this.linkSource.asObservable();

  setIosAndroidURL(url: string, showAppBanner) {
    const urls = url.split(',');
    const iosURL = urls[0];
    const androidURL = urls[1];
    const links: any = {
      iosURL,
      androidURL,
      showAppBanner,
    };
    this.linkSource.next(links);
  }
}
